import type { QuestionnaireResponseItem } from '@medplum/fhirtypes';
import { getItemAnswerText } from '../pages/appointments/fhirNoteMapping';
import { stripHtml } from '../pages/appointments/utils/stripHtml';
import { sanitizeHtml } from './template-setup/convert';

/** True when a string contains HTML markup (consent forms, rich-text blocks). */
export function looksLikeHtml(text: string): boolean {
  return /<(?:p|ol|ul|li|div|br|strong|em|h[1-6]|table|blockquote)\b/i.test(text);
}

export type ResponseItemDisplayMode = 'rich-html' | 'plain';

export function getResponseItemDisplayMode(item: QuestionnaireResponseItem): ResponseItemDisplayMode {
  const answerText = getItemAnswerText(item);
  if (answerText && looksLikeHtml(answerText)) {
    return 'rich-html';
  }
  const questionText = item.text ?? '';
  if (!answerText && questionText && looksLikeHtml(questionText)) {
    return 'rich-html';
  }
  return 'plain';
}

export function richHtmlForResponseItem(item: QuestionnaireResponseItem): string {
  const answerText = getItemAnswerText(item);
  if (answerText && looksLikeHtml(answerText)) {
    return sanitizeHtml(answerText);
  }
  return sanitizeHtml(item.text ?? '');
}

export function plainQuestionText(item: QuestionnaireResponseItem): string {
  return stripHtml(item.text ?? item.linkId ?? '');
}

export function plainAnswerText(item: QuestionnaireResponseItem): string {
  return stripHtml(getItemAnswerText(item));
}
